<template>
  <div style="text-align: center; cursor: default; user-select: none;">SRD © 2021 立维研发组</div>
</template>

<script>
export default {
  name: 'Footer'
}
</script>
